// --- Dependencies -------------------------------------------------------------------------------
import { create } from "zustand";
import { persist } from "zustand/middleware";
// --- Our Modules --------------------------------------------------------------------------------
import constants from "@/config/constants";
// --- Logic --------------------------------------------------------------------------------------
type TyPageSizeStore = { pageSize: number; setPageSize: (size: number) => void };

/**
 * How many rows every list asks for — one setting, set from any paginator and obeyed by all of them.
 * It is a preference about a person's own screen rather than a property of a list, so it lives beside
 * the language instead of in each screen's URL.
 *
 * Clamped on the way in: the endpoints cap `limit`, so a bigger number here would quietly mean a
 * different page size than the one on screen.
 */
const usePageSize = create<TyPageSizeStore>()(
    persist(
        (set) => ({
            pageSize: constants.pageSize,
            setPageSize: (size) => set({ pageSize: Math.max(constants.minPageSize, Math.min(constants.maxPageSize, Math.round(size))) }),
        }),
        { name: "page-size" }
    )
);

export default usePageSize;
